export type YearEndModalContext = {
  currentStart: string;
  currentEnd: string;
  previousStart: string;
  previousEnd: string;
  firstYear: string; // 'Y' or 'N'
  filingId: string;
  orgId: string;
  onSuccess: () => void; // Redirect to filings page
};

let currentContext: YearEndModalContext | null = null;

export const YEAR_END_MODAL_OPEN_EVENT = 'yearEndModal:open';
export const YEAR_END_MODAL_CLOSE_EVENT = 'yearEndModal:close';

export function setYearEndModalContext(ctx: YearEndModalContext) {
  currentContext = ctx;
}

export function getYearEndModalContext() {
  return currentContext;
}

export function openYearEndModal() {
  document.dispatchEvent(new CustomEvent(YEAR_END_MODAL_OPEN_EVENT));
}

export function closeYearEndModal() {
  document.dispatchEvent(new CustomEvent(YEAR_END_MODAL_CLOSE_EVENT));
}

